import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Third party
import { NgArrayPipesModule } from 'ngx-pipes';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip/tooltip.module';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { NgSelectModule } from '@ng-select/ng-select';

// Local modules
import { SharedModule } from '../shared/shared.module';
import { IwFormsModule } from '../forms/iw-forms.module';

// Local components
import { ActivityComponent } from './activity/activity.component';
import { TaskComponent } from './task/task.component';
import { FlowComponent } from './flow.component';
import { NotifierService } from '@app/flow/shared';
import { ElementsHelperComponent } from './elements-helper/elements-helper.component';
import { SelectTramiteComponent } from './select-tramite/select-tramite.component';
import { TitleComponent } from '@app/flow/title';
import { GhostBoxComponent } from './ghost-box/ghost-box.component';
import { DynamicContentFormComponent } from '@app/forms/dynamic-content-form/dynamic-content-form.component';
import { ObservationProcessComponent } from './observation-process/observation-process.component';
import { StageComponent } from './title/stage/stage.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TooltipModule,
    BsDropdownModule,
    NgArrayPipesModule,
    NgxPaginationModule,
    PaginationModule,
    ScrollToModule,
    NgSelectModule,
    CollapseModule,
    IwFormsModule,
    ButtonsModule.forRoot()
  ],
  declarations: [
    ActivityComponent,
    TaskComponent,
    FlowComponent,
    ElementsHelperComponent,
    SelectTramiteComponent,
    TitleComponent,
    GhostBoxComponent,
    ObservationProcessComponent,
    StageComponent
  ],
  exports: [
    ActivityComponent,
    TaskComponent,
    FlowComponent,
    ElementsHelperComponent,
    SelectTramiteComponent,
    TitleComponent,
    GhostBoxComponent
  ],
  entryComponents: [
    DynamicContentFormComponent
  ],
  providers: [NotifierService]
})
export class FlowModule {}



// WEBPACK FOOTER //
// ./src/app/flow/flow.module.ts